// Used to categorize words within a round.
// While many rounds have their own internal WordCompletionStatus enum, this
// one is more generic and is used in round-agnostic components.

export const WordStatus = {
  UPCOMING: 0,
  CURRENT: 1,
  INCORRECT: 2,
  CORRECT: 3,
  PARTIALLY_CORRECT: 4,
};

export type WordStatus =
  | typeof WordStatus.UPCOMING
  | typeof WordStatus.CURRENT
  | typeof WordStatus.CORRECT
  | typeof WordStatus.INCORRECT
  | typeof WordStatus.PARTIALLY_CORRECT;
